import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_DELAY_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    // Travel Delay
    travelDelay: 'false',
    didTheDelayOccurDuringDeparture: null,
    didTheDelayOccurDuringArrival: null,
    reasonsForDelay: [],
    dateYouWereDueToDepart: '',
    timeYouWereDueToDepart: null,
    dateTripWasDelayed: '',
    dateDelayEnded: '',
    dateYouActuallyDeparted: '',
    timeYouActuallyDeparted: null,
    delayInformationItems: [],
    detailsRegardingYourTripDelay: '',
    scheduledDateOfDeparture: '',
    scheduledTimeOfDeparture: null,
    actualDateOfDeparture: '',
    actualTimeOfDeparture: null,
    scheduledDateOfArrival: '',
    scheduledTimeOfArrival: null,
    actualDateOfArrival: '',
    actualTimeOfArrival: null,

    // Missed Connection
    missedConnection: 'false',
    reasonsForMissedConnection: [],
    didTheDelayOccurDuringDepartureForMissedConnection: null,
    didTheDelayOccurDuringArrivalForMissedConnection: null,
    scheduledDateOfDepartureForMissedConnection: '',
    scheduledTimeOfDepartureForMissedConnection: null,
    scheduledDateOfArrivalForMissedConnection: '',
    scheduledTimeOfArrivalForMissedConnection: null,
    detailsRegardingYourMissedConnection: '',
    missedConnectionInformationItems: [],
    actualDateOfDeparturForMissedConnection: '',
    actualTimeOfDepartureForMissedConnection: null,
    actualDateOfArrivalForMissedConnection: '',
    actualTimeOfArrivalForMissedConnection: null,
  },
  errors: [],
});

const initialTravelDelayState = {
  form: {
    travelDelay: 'false',
    reasonsForDelay: [],
    companyNameTravelDelay: '',
    addressTravelDelay: '',
    cityTravelDelay: '',
    stateTravelDelay: '',
    zipCodeTravelDelay: '',
    contactTravelDelay: '',
    phoneNumberTravelDelay: '',
    dateOfInitialPaymentDeposit: '',
    includedInPackageForDelay: '',
    dateYouWereDueToDepart: '',
    timeYouWereDueToDepart: null,
    dateTripWasDelayed: '',
    dateDelayEnded: '',
    dateYouActuallyDeparted: '',
    timeYouActuallyDeparted: null,
    delayInformationItems: [],
  },
};

function stepTravelDelayReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_DELAY_STATE:
      return state
          .setIn(['form', 'delayInformationItems'], [])
          .mergeDeep(initialTravelDelayState);
    default:
      return state;
  }
}

export default stepTravelDelayReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepTravelDelay/reducer.js